import { createTheme } from '@mui/material/styles';

// Static light-mode theme. Single source of palette/typography/component
// overrides — every page reads these tokens via MUI. Shared so components
// rendered outside the main page tree (e.g. the global App Details drawer)
// get the exact same styling and the UI stays unified.
export const appTheme = createTheme({
  palette: {
    primary: { main: '#6366f1', light: '#a5b4fc', dark: '#4338ca', contrastText: '#fff' },
    secondary: { main: '#8b5cf6', light: '#c4b5fd', dark: '#6d28d9', contrastText: '#fff' },
    success: { main: '#16a34a', light: '#86efac', dark: '#15803d', contrastText: '#fff' },
    warning: { main: '#f59e0b', light: '#fcd34d', dark: '#b45309', contrastText: 'rgba(0, 0, 0, 0.87)' },
    error:   { main: '#dc2626', light: '#fca5a5', dark: '#991b1b', contrastText: '#fff' },
    info:    { main: '#3b82f6', light: '#93c5fd', dark: '#1d4ed8', contrastText: '#fff' },
    background: { default: '#f8fafc', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#475569' },
    divider: 'rgba(15, 23, 42, 0.08)',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 800, letterSpacing: '-0.01em' },
    h5: { fontWeight: 800, letterSpacing: '-0.005em' },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiContainer: { defaultProps: { maxWidth: 'xl' } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 700, borderRadius: 10 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiTooltip: {
      styleOverrides: { tooltip: { fontSize: '0.75rem', backgroundColor: 'rgba(15, 23, 42, 0.92)', borderRadius: 6 } },
    },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1240, xl: 1600 },
  },
});
